import React from "react";
import { Loader2 } from "lucide-react";

interface UploadingOverlayProps {
  loading: boolean;
  loadingLabel: string;
  loadingProgress: number | undefined;
}

export const UploadingOverlay: React.FC<UploadingOverlayProps> = ({ loading, loadingLabel, loadingProgress }) => {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/60 backdrop-blur-xs select-none">
      <Loader2 className="size-8 text-white animate-spin mb-3" />
      <p className="text-white text-sm font-semibold tracking-wide">
        {loadingLabel} {loadingProgress !== undefined ? `${loadingProgress}%...` : ""}
      </p>
    </div>
  );
};
